import { z } from "zod";
import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
  type CountryCode,
} from "libphonenumber-js/max";

export const schema = z.object({
  phone: z
    .object({
      number: z.string().trim().min(1, "El número de teléfono es obligatorio"),
      calling_code: z
        .string()
        .trim()
        .min(1, "El código de país es obligatorio"),
      country: z.string().trim().min(1, "El país es obligatorio"),
    })
    .superRefine((value, ctx) => {
      if (!value.number) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["number"],
          message: "El número de teléfono es obligatorio",
        });

        return;
      }

      const isValid =
        isValidPhoneNumber(value.number, value.country as CountryCode) &&
        isPossiblePhoneNumber(value.number, value.country as CountryCode);

      if (!isValid) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["number"],
          message: "Formato invalido",
        });
      }
    }),
});
export type UpdateProfileFormData = z.infer<typeof schema>;
